var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinPosition(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.038,
    height: 20.055,
    viewBox: "0 0 14.038 20.055",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-pin-drop",
    "data-name": "Icon material-pin-drop",
    d: "M20.536,9.016a6.016,6.016,0,1,0-12.033,0c0,4.512,6.016,11.03,6.016,11.03S20.536,13.529,20.536,9.016Zm-8.022,0a2.005,2.005,0,1,1,2.005,2.005A2.011,2.011,0,0,1,12.514,9.016ZM7.5,21.049v2.005H21.538V21.049Z",
    transform: "translate(-7.5 -3)",
    fill: "#3260ce"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinPosition);
export default __webpack_public_path__ + "static/media/pin-position.f93115559f84fce7c60a977a01b49bc3.svg";
export { ForwardRef as ReactComponent };